<template>
  <b-row>
    <b-col
      cols="12"
      sm="12"
      class="d-flex align-items-center justify-content-center justify-content-sm-end"
    >
      <b-pagination
        v-if="currentPage"
        :value="currentPage"
        :total-rows="total"
        :per-page="perPage"
        first-number
        last-number
        class="mb-0 mt-1 mt-sm-0"
        prev-class="prev-item"
        next-class="next-item"
        @change="handlePagination"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BPagination,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BPagination,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    currentPage() {
      return this.data.current_page
    },
    total() {
      return this.data.total
    },
    perPage() {
      return this.data.per_page
    },
  },
  methods: {
    handlePagination(page) {
      this.$router.push({ query: { ...this.$route.query, page } }).catch(() => {})
      this.paginationHandle(this.action, {
        ...this.payload,
        ...this.$route.query,
        page,
      })
    },
  },
}
</script>
